import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import DownloadPdf from 'wt-react/dist/components/DownloadPdf/DownloadPdf'
import ReactTooltip from 'react-tooltip'
import {
  updateFundCount,
  loadFundDetailsPortfolio,
  loadFundProfile,
  loadRelatedFunds,
  setTAFundTickers,
  paneOpts,
  removeTicker,
  clearTickers,
  loadFundDetailsExcel,
  loadFundDetailsFromTickers,
  loadFundDetailsFromExternalIDs,
  removeRelatedFund,
  setActivePane,
  setPerfStartDate,
  setPerfEndDate,
  saveToGA,
  resetPage,
  toggleFundSelection,
  appendSearchTicker,
  addScreenedFund,
  hardSetScreendFunds
} from '../../actions'
import { loadModelStrategies, loadPersonalStrategies } from '../../actions/data'
import KeyMetrics from './KeyMetrics/KeyMetrics'
import RelatedFunds from './RelatedFunds/RelatedFunds'
import FundSelector from './FundSelector/FundSelector'
import FundScreener from './FundScreener/FundScreener' //'@bit/wisdomtree.reactcomponents.input.fundselector';
import StrategyList from './StrategyList/StrategyList'
import ModelList from './ModelList/ModelList'
import CharsTable from './CharsTable/CharsTable'
import Exposures from './Exposures/Exposures'
import Performance from './Performance/Performance'
import Details from './Details/Details'
import Esg from './Esg/Esg'
import Factors from './Factors/Factors'
import FundSelect from './FundSelect/FundSelect'
import NavBar from './NavBar/NavBar'
import { defaultPairs } from './defaultpairsdata'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faEraser,
  faRefresh,
  faMinusCircle,
  faCircleNotch,
  faList,
  faCopy,
  faFilePdf,
  faFileExcel,
  faAngleDoubleDown,
  faAngleDown,
  faPlus,
  faMinus,
  faTable,
  faXmark,
  faTriangleExclamation
} from '@fortawesome/free-solid-svg-icons'
import i18n from '../../i18n'
import './App.css'
import './DownloadPdf.css'
import TickerSelection from './TickerSelection/TickerSelection'
import { Spinner, SpinnerSmall } from './Components/Spinner'
library.add(
  faEraser,
  faRefresh,
  faMinusCircle,
  faCircleNotch,
  faList,
  faCopy,
  faFilePdf,
  faFileExcel,
  faAngleDoubleDown,
  faAngleDown,
  faPlus,
  faMinus,
  faTable,
  faXmark,
  faTriangleExclamation
)

const TICKER_SEARCH = 'ticker'
const TEXT_SEARCH = 'search'
const LIST_PORTFOLIOS = 'portfolios'
const LIST_MODELS = 'models'

class App extends Component {
  constructor(props) {
    super(props)
    this._child = React.createRef()
    this.state = {
      defaultPairs: defaultPairs,
      selectType: TICKER_SEARCH,
      showPdfModal: false,
      portfolioToSave: null,
      runFromURL: false
    }

    this.setSelectType = this.setSelectType.bind(this)
    this.toggleShowPdfModal = this.toggleShowPdfModal.bind(this)
  }

  componentWillMount() {
    //this.props.loadPersonalStrategies()
    //this.props.getBenchmarks()
    // this.unlisten = this.listenForUrlChanges()

    const { history, isLoggedIn, isFP } = this.props
    if (!isLoggedIn) {
      this.props.loadFundProfile()
    }

    const hash = history.location.hash.substring(1)
    if (hash !== '') {
      const hash = history.location.hash.substring(1).split('&')
      this.hashActions(hash)
    }

    history.listen(() => {
      const hash = history.location.hash.substring(1).split('&')
      this.hashActions(hash)
    })

    if (isLoggedIn && isFP) {
      this.props.loadModelStrategies()
    }

    if (isLoggedIn) {
      this.props.loadPersonalStrategies()
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.loading !== this.props.loading) {
      this.setState({ runFromURL: false });
    }
  }

  hashActions = (hash) => {
    if (hash.length > 1 && (hash[0] === 'fundchar' || hash[0] === 'fund-comparison')) {
      let inputSelections = [];
  
      hash.forEach((item) => {
        if (item.includes('startDate=')) {
          const start = item.split('startDate=')[1];
          this.props.setPerfStartDate(start);
        }
  
        if (item.includes('endDate=')) {
          const end = item.split('endDate=')[1];
          this.props.setPerfEndDate(end);
        }
  
        if (item.includes('tickers=')) {
          const tickers = item.split('tickers=')[1]; 
          const tickersArray = tickers.split(',').map(v => v.toUpperCase());
  
          inputSelections = tickersArray.map((ticker, index) => ({
            id: `${ticker}_${index}`,
            externalID: ticker, 
            ticker: ticker,
            rebalance_fq: "",
            name: "",
            type: "ticker"
        }));
        }
  
        if (item.includes('portfolio=')) {
          const portfolio = item.split('portfolio=')[1]; 
          const portfolioArray = portfolio.split(',').map(v => v.toUpperCase());
  
          const portfolioFormatted = portfolioArray.map((portfolio, index) => ({
            id: `${portfolio}_${index}`, 
            externalID: portfolio,
            ticker: portfolio,
            rebalance_fq: "",
            name: "",
            type: "user_model"
          }));
  
          inputSelections = [...inputSelections, ...portfolioFormatted];
        }
  
        const lowerCaseItem = item.toLowerCase();
        if (lowerCaseItem.includes('landingtab=')) {
          const landingTabValue = lowerCaseItem.split('landingtab=')[1];
        
          if (landingTabValue === '3') {
            this.setState({ selectType: LIST_PORTFOLIOS });
          } else if (landingTabValue === '4') {
            this.setState({ selectType: LIST_MODELS });
          }
        }
        
        

        if (item.includes('tab=')) {
          const tab = item.split('tab=')[1];
          this.props.setActivePane(tab);
        }        
      });
  
      if (inputSelections.length > 0) {  
        // post to redux
        this.props.hardSetScreendFunds(inputSelections);
  
        // trigger the dataload
        this.props.loadFundDetailsPortfolio();
      }
    }
  };
  
  

  getSaveToGA = event => {
    event.preventDefault()
    this.props.saveToGA('Copy Link')
  }

  getRelatedFunds = tickers => {
    this.props.loadRelatedFunds(tickers)
  }

  getDataTypeAhead = tickers => {
    this.props.setTAFundTickers(tickers)
  }

  getExcelDownload = (event, fullPeriod) => {
    event.preventDefault()
    this.props.loadFundDetailsExcel(fullPeriod)
  }

  removeTicker(ticker) {
    this.props.removeTicker(ticker)
  }

  clearTickers() {
    this.props.clearTickers()
  }

  handleResubmit = () => {
    const { loadFundDetailsPortfolio } = this.props
    loadFundDetailsPortfolio()
  }

  asOfDate() {
    const fund = this.props.data[0]
    const value = fund['aggregateFundamentals'][fund['aggregateFundamentals'].length - 1]
    return new Date(value.date).toLocaleString().split(',')[0].split(' ')[0]
  }

  setSelectType(newSelectType) {
    this.setState({ selectType: newSelectType })
  }

  renderTATickers() {
    const { data } = this.props
    return data.map((fund, idx) => {
      return (
        <div key={fund.ticker} className='taTicker' data-tip data-for={`ticker-${idx}`}>
          {fund.ticker}
          <ReactTooltip
            id={`ticker-${idx}`}
            type='light'
            className='fundtip'
            effect='float'
          >
            <div dangerouslySetInnerHTML={{ __html: fund.name }} />
          </ReactTooltip>
        </div>
      )
    })
  }

  toggleFundSelectionBoxes = () => {
    const { isLoggedIn, showFundSelection } = this.props

    // For logged-out users, reopening the selector should restore category options.
    if (!isLoggedIn && !showFundSelection) {
      this.props.resetPage('keep-data')
    }

    this.props.toggleFundSelection()
  }

  toggleShowPdfModal = () => {
    this.setState({ showPdfModal: !this.state.showPdfModal })
  }

  selectRelatedFund = fund => {
    const appendToTickerSearch = {
      value: fund.externalID,
      label: fund.name + ' (' + fund.ticker + ')',
      name: fund.name,
      ticker: fund.ticker
    }
    const appendToFundSearch = {
      externalID: fund.externalID,
      name: fund.name,
      ticker: fund.ticker
    }
    this.props.appendSearchTicker(appendToTickerSearch)
    this.props.addScreenedFund(appendToFundSearch)
    this.props.removeRelatedFund(fund)
  }

  openInNewTab = url => {
    window.open(url, '_blank', 'noopener,noreferrer')
  }

  renderSelectType() {
    const { selectType } = this.state
    const { showFundSelection, data, isLoggedIn, isFP } = this.props

    return (
      <div className='selectButtonRow'>
        <div className='selectType'>
          <button
            className='button'
            onClick={() => this.setSelectType(TICKER_SEARCH)}
            disabled={selectType === TICKER_SEARCH}
          >
            {i18n.t('ticker-search')}
          </button>
          <button
            className='button'
            onClick={() => this.setSelectType(TEXT_SEARCH)}
            disabled={selectType === TEXT_SEARCH}
          >
            {i18n.t('fund-screener')}
          </button>
          {isLoggedIn && (
            <button
              className='button'
              onClick={() => this.setSelectType(LIST_PORTFOLIOS)}
              disabled={selectType === LIST_PORTFOLIOS}
            >
              {i18n.t('view-portfolios')}
            </button>
          )}
          {isLoggedIn && isFP && (
            <button
              className='button'
              onClick={() => this.setSelectType(LIST_MODELS)}
              disabled={selectType === LIST_MODELS}
            >
              {i18n.t('view-models')}
            </button>
          )}
        </div>

        {/* When data is loaded show a close button so the fund selection can be shut */}
        {showFundSelection && data && data.length > 0 ? (
          <div className='closeFundSelector'>
            <button className='button' onClick={() => this.toggleFundSelectionBoxes()}>
              <FontAwesomeIcon icon='fa-xmark' />
            </button>
          </div>
        ) : null}
      </div>
    )
  }

  renderFundSelection() {
    const {
      data,
      loading,
      error,
      initialTickers,
      personalStrategiesError,
      modelStrategiesError
    } = this.props
    const { selectType, runFromURL } = this.state
    let maxSelect = data ? 6 - data.length : 6

    return (
      <div className='fundSelection'>
        {!loading && this.renderSelectType()}
        {!loading && selectType === TICKER_SEARCH ? (
          <React.Fragment>
            <div className='row'>
              <div className='selectCopy col-sm-12'>{i18n.t('select-funds')}</div>
              <div className='selectBenchmark col-sm-12'>
                {i18n.t('default-benchmark-select')}
              </div>
            </div>
            {!runFromURL && <FundSelector
              ref={this._child}
              submitFundsToAnalyze={this.getDataTypeAhead}
              typeaheadUrl={`${process.env.REACT_APP_API_URL}/fundchar/typeahead/`}
              tickerNamesUrl={`${process.env.REACT_APP_API_URL}/fundchar/tickernames/`}
              tickerSelected={this.getRelatedFunds}
              wtRegion='US'
              initialTickers={initialTickers}
              showUpload={false}
              maxFunds={maxSelect}
              //currentFunds={[]}
            />}
            <RelatedFunds action={this.selectRelatedFund} />
          </React.Fragment>
        ) : null}
        {!loading && selectType === TEXT_SEARCH ? <FundScreener /> : null}
        {error && (selectType === TEXT_SEARCH || selectType === TICKER_SEARCH )&& (
          <div className='row'>
            <div className={'col-sm-12'}>
              <div
                className='loadingCopy'
                style={{ textAlign: 'center', marginTop: '60px' }}
              >
                {i18n.t('error-processing-request')}
              </div>
            </div>
          </div>
        )}

        {!loading && selectType === LIST_PORTFOLIOS ? <StrategyList /> : null}
        {personalStrategiesError && selectType === LIST_PORTFOLIOS  && (
          <div className='row'>
            <div className={'col-sm-12'}>
              <div
                className='loadingCopy'
                style={{ textAlign: 'center', marginTop: '60px' }}
              >
                {i18n.t('error-processing-portfolios')}
              </div>
            </div>
          </div>
        )}

        {!loading && selectType === LIST_MODELS ? <ModelList /> : null}
        {modelStrategiesError && selectType === LIST_MODELS && (
          <div className='row'>
            <div className={'col-sm-12'}>
              <div
                className='loadingCopy'
                style={{ textAlign: 'center', marginTop: '60px' }}
              >
                {i18n.t('error-processing-request')}
              </div>
            </div>
          </div>
        )}
      </div>
    )
  }

  // Show the fund selection segment if necessary
  renderFundSelect() {
    const { data, showFundSelection, loading, error, isLoggedIn, loadingStructure } =
      this.props

    if (!isLoggedIn) {
      if (loading && !error && (data?.length === 0 || !data)) {
        return <Spinner />
      }
      return showFundSelection ? <FundSelect /> : null
    } else if (loadingStructure) {
      return <Spinner />
    } else if (loading && !error && (data?.length === 0 || !data)) {
      return <Spinner />
      // If there isn't data then render the fund selection options
    } else if (!data || showFundSelection) {
      return this.renderFundSelection()
    }
    // If there is data but can still add more funds, then render the 'Add more' link
    else {
      return null
    }
  }

  renderActivePane() {
    const { activePane } = this.props

    switch (activePane) {
      case paneOpts.metrics:
        return <KeyMetrics />
      case paneOpts.chars:
        return <CharsTable />
      case paneOpts.expos:
        return <Exposures />
      case paneOpts.factors:
        return <Factors />
      case paneOpts.esg:
        return <Esg />
      case paneOpts.perf:
        return <Performance />
      case paneOpts.details:
        return <Details />
      default:
        return null
    }
  }

  renderPdf() {
    const {
      runId,
      runEmail,
      token,
      pdfReportConfigId,
    } = this.props
    const { showPdfModal } = this.state

    // If user is signed in and has a token then allow the pdf button
    let downloadPdf
    if (token && pdfReportConfigId) {
      downloadPdf = (
        <div>
          <button
            className='button'
            onClick={event => this.toggleShowPdfModal()}
            data-tip
            data-for={`hover-tip-pdf`}
          >
            <FontAwesomeIcon icon='file-pdf' size='1x' />
          </button>
          <ReactTooltip
            key={`hover-tip-pdf`}
            id={`hover-tip-pdf`}
            type='light'
            textColor='#5b6770'
            arrowColor='transparent'
            effect='float'
            getContent={() => {
              return null
            }}
            multiline={false}
          >
            {i18n.t('download-pdf-file')}
          </ReactTooltip>
          {/* Show the PDF modal when the button is clicked */}
          {showPdfModal ? (
            <DownloadPdf
              token={token}
              clientEmail={runEmail}
              configId={pdfReportConfigId}
              initialButtonText={i18n.t('download-pdf')}
              modalTitleText={i18n.t('download-pdf')}
              waitingMessageText={i18n.t('waiting-message-text')}
              dataspanApiUrl={process.env.REACT_APP_API_URL}
              dpdApiUrl={process.env.REACT_APP_DPD_API_URL}
              openModalOnLoad={true}
              submitOnLoad={false}
              showCloseText={false}
              callbackOnClose={this.toggleShowPdfModal}
              adhocInputs={[
                {
                  name: 'id',
                  type: 'string',
                  value: runId
                },
                {
                  name: 'token',
                  type: 'string',
                  value: token
                },
                {
                  name: 'email',
                  type: 'string',
                  value: runEmail
                }
              ]}
            />
          ) : null}
        </div>
      )
    } else if (pdfReportConfigId) {
      downloadPdf = (
        <div>
          <span data-tip data-for={`hover-tip-pdf-restricted`}>
            <button disabled={true} className='button'>
              {' '}
              <FontAwesomeIcon icon='file-pdf' size='1x' style={{ color: '#050139' }} />
            </button>
          </span>
          <ReactTooltip
            key={`hover-tip-pdf-restricted`}
            id={`hover-tip-pdf-restricted`}
            type='light'
            textColor='#5b6770'
            arrowColor='transparent'
            effect='float'
            getContent={() => {
              return null
            }}
            multiline={false}
          >
            {i18n.t('download-pdf-restrictred')}
          </ReactTooltip>
        </div>
      )
    }

    return downloadPdf
  }

  render() {
    const {
      isLoggedIn,
      tickers,
      fcShowData,
      currentExcelStatus,
      fullExcelStatus,
      currentURL,
      showFundSelection,
    } = this.props


    if (isLoggedIn || tickers) {
      return (
        <div className='fundChar' style={{ paddingTop: '20px' }}>
          {this.renderFundSelect()}
          {fcShowData === 'show' && (
            <div>
              <div
                className='row'
                style={{ marginBottom: '10px', marginTop: '35px', display: 'fex' }}
              >
                <div className={'col-md-10'}>
                  {isLoggedIn && (
                    <div>
                      {!showFundSelection && <TickerSelection resultsScreen={true} />}
                    </div>
                  )}
                </div>
                <div className='col-md-2'>
                  <div className='navAppButtons'>
                    {(
                      <div>
                        <button
                          className={showFundSelection ? 'enabled' : 'button'}
                          onClick={() => this.toggleFundSelectionBoxes()}
                          data-tip
                          data-for={`hover-tip-addmore`}
                        >
                          <FontAwesomeIcon
                            icon={showFundSelection ? 'minus' : 'plus'}
                            size='1x'
                          />
                        </button>
                        <ReactTooltip
                          key={`hover-tip-addmore`}
                          id={`hover-tip-addmore`}
                          type='light'
                          textColor='#5b6770'
                          arrowColor='transparent'
                          effect='float'
                          getContent={() => {
                            return null
                          }}
                          multiline={false}
                        >
                          {showFundSelection
                            ? i18n.t('close-fund-selection')
                            : i18n.t('add-more-funds')}
                        </ReactTooltip>
                      </div>
                    )}

                    <div>
                      <button
                        className='button'
                        onClick={() =>
                          this.openInNewTab('https://www.wisdomtree.com/glossary')
                        }
                        data-tip
                        data-for={`hover-tip-glossary`}
                      >
                        <FontAwesomeIcon icon='list' size='1x' />
                      </button>
                      <ReactTooltip
                        key={`hover-tip-glossary`}
                        id={`hover-tip-glossary`}
                        type='light'
                        textColor='#5b6770'
                        arrowColor='transparent'
                        effect='float'
                        getContent={() => {
                          return null
                        }}
                        multiline={false}
                      >
                        {i18n.t('glossary of terms')}
                      </ReactTooltip>
                    </div>
                    <div>
                      <CopyToClipboard text={currentURL}>
                        <button
                          className='button'
                          onClick={event => this.getSaveToGA(event)}
                          data-tip
                          data-for={`hover-tip-copylink`}
                        >
                          <FontAwesomeIcon icon='copy' size='1x' />
                        </button>
                      </CopyToClipboard>
                      <ReactTooltip
                        key={`hover-tip-copylink`}
                        id={`hover-tip-copylink`}
                        type='light'
                        textColor='#5b6770'
                        arrowColor='transparent'
                        effect='float'
                        getContent={() => {
                          return null
                        }}
                        multiline={false}
                      >
                        {i18n.t('copy-link')}
                      </ReactTooltip>
                    </div>
                    {/* Download PDF */}
                    {this.renderPdf()}

                    {!currentExcelStatus && (
                      <React.Fragment>
                        <div>
                          <button
                            className='button'
                            onClick={event => this.getExcelDownload(event, false)}
                            data-tip
                            data-for={`hover-tip-current`}
                          >
                            <FontAwesomeIcon icon='angle-down' size='1x' />
                          </button>
                          <ReactTooltip
                            key={`hover-tip-current`}
                            id={`hover-tip-current`}
                            type='light'
                            textColor='#5b6770'
                            arrowColor='transparent'
                            effect='float'
                            getContent={() => {
                              return null
                            }}
                            multiline={false}
                          >
                            {i18n.t('export-current')}
                          </ReactTooltip>
                        </div>
                      </React.Fragment>
                    )}
                    {currentExcelStatus && (
                      <div className='excelInProgress'>
                        <button className='button'>
                          <SpinnerSmall colour={'white'} />
                        </button>
                      </div>
                    )}
                    {!fullExcelStatus && (
                      <div>
                        <button
                          className='button'
                          onClick={event => this.getExcelDownload(event, true)}
                          data-tip
                          data-for={`hover-tip-full`}
                        >
                          <FontAwesomeIcon icon='angle-double-down' size='1x' />
                        </button>
                        <ReactTooltip
                          key={`hover-tip-full`}
                          id={`hover-tip-full`}
                          type='light'
                          textColor='#5b6770'
                          arrowColor='transparent'
                          effect='float'
                          getContent={() => {
                            return null
                          }}
                          multiline={false}
                        >
                          {i18n.t('export-full-period')}
                        </ReactTooltip>
                      </div>
                    )}
                    {fullExcelStatus && (
                      <div>
                        <button className='button'>
                          <SpinnerSmall colour={'white'} />
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <NavBar />
              {this.renderActivePane()}
            </div>
          )}
        </div>
      )
    } else {
      return (
        <div className='fundChar' style={{ paddingTop: '20px' }}>
          <Spinner />
        </div>      
      )
    }
  }
}

function mapStateToProps(state) {
  return {
    advisorEmail: state.params.advisorEmail,
    data: state.fundData.data,
    tickers: state.fundData.tickers,
    fcShowData: state.fundData.fcShowData,
    loading: state.fundData.loading,
    error: state.fundData.error,
    selectedSector: state.params.selectedSector,
    selectedCountry: state.params.selectedCountry,
    isFP: state.params.isFP,
    initialTickers: state.params.initialTickers,
    activePane: state.params.activePane,
    version: state.params.version,
    fullExcelStatus: state.params.fullExcelStatus,
    currentExcelStatus: state.params.currentExcelStatus,
    currentURL: state.params.currentURL,
    runId: state.fundData.runId,
    runEmail: state.fundData.runEmail,
    token: state.params.token,
    pdfReportConfigId: state.params.pdfReportConfigId,
    showFundSelection: state.params.showFundSelection,
    screenedFunds: state.params.screenedFunds,
    count: state.params.count,
    resultsScreen: state.params.resultsScreen,
    isLoggedIn: state.params.isLoggedIn,
    loadingStructure: state.fundData.loadingStructure,
    personalStrategiesError: state.data.personalStrategiesError,
    modelStrategiesError: state.data.modelStrategiesError,
  }
}

export default withRouter(
  connect(mapStateToProps, {
    loadFundProfile,
    loadRelatedFunds,
    setTAFundTickers,
    removeTicker,
    clearTickers,
    updateFundCount,
    loadFundDetailsExcel,
    loadFundDetailsFromTickers,
    loadFundDetailsFromExternalIDs,
    removeRelatedFund,
    setActivePane,
    setPerfStartDate,
    setPerfEndDate,
    saveToGA,
    resetPage,
    toggleFundSelection,
    appendSearchTicker,
    addScreenedFund,
    loadFundDetailsPortfolio,
    loadModelStrategies,
    loadPersonalStrategies,
    hardSetScreendFunds
  })(App)
)
